import React from "react";
import { Redirect } from "react-router-dom";

export default class Dashboard extends React.Component {
  render() {
    return <Redirect to="/admin/reports" />;
  }
}
